import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'lib-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent implements OnChanges {
  @Input() color?: string;
  @Input() textColor?: string;
  @Input() icon?: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() disabledBgColor?: string;
  @Input() disabledTextColor?: string;
  @Input() disabledBorderColor?: string;
  @Input() img?: string;

  isThemeColor = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) {
      const colorValue = this.color;
      this.isThemeColor =
        colorValue === 'primary' ||
        colorValue === 'accent' ||
        colorValue === 'warn';
    }
  }
}
